/**
 * Application Constants
 * Centralized configuration values
 */

// Accordion Configuration
export const ACCORDION_CONFIG = {
  timerDuration: 15000, // UPDATE SCSS ANIMATION DURATION IF CHANGED -> _accordion.scss LINE 106
  animationClass: 'animating',
  activeClass: 'active',
  manualSelectedClass: 'manual-selected'
};

// Sticky Navigation Configuration
export const STICKY_NAV_CONFIG = {
  activeClass: 'active',
  stickyClass: 'is-sticky',
  scrollOffset: 20,
  observerOffset: 100
};

// Scroll Configuration
export const SCROLL_CONFIG = {
  throttleDelay: 16, // ~60fps
  debounceDelay: 300,
  smoothScrollOffset: 20
};

// Breakpoints (should match SCSS breakpoints)
export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280,
  wide: 1536
};

// Component Selectors
export const SELECTORS = {
  featureAccordion: '.feature-accordion',
  collectAccordion: '.collect-accordion',
  analyzeAccordion: '.analyse-accordion',
  shareAccordion: '.share-accordion',
  stickyNav: '#jumpLinksNav',
  mobileMenuToggle: '.nav__toggle',
  accordionItem: '.accordion-item',
  jumpLink: '.jump-link',
  headerNavDropdown: '.nav__item--dropdown',
  headerNavDropdownButton: '.nav__link--dropdown',
  headerNavDropdownMenu: '.nav__dropdown',
  headerNavLinks: '.nav__links a',
  contactForm: '.contact-form'
};

// Data Attributes
export const DATA_ATTRIBUTES = {
  component: 'data-component',
  accordion: 'data-accordion',
  image: 'data-image'
};
